import { CloseIcon } from '@atoms/Icons/CloseIcon';
import { Table } from '@molecules';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { SocialMediaHistoryType } from '@services';
import { StyledDialogTitle, StyledHeaderModal, stylesCloseIcon } from './socialMediaHistory.styles';
import CompareCell from './CompareCell';
import { GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';

interface IModalProps {
  modelId: string;
  id: string;
  onCancel: () => void;
  open: boolean;
}

export const SocialMediaHistoryModal = ({ modelId, id, open, onCancel }: IModalProps) => {
  const columns: GridColDef<SocialMediaHistoryType>[] = [
    {
      field: 'changeNumber',
      headerName: 'Change Number',
      sortable: false,
      filterable: false,
      renderHeader: () => (
        <Box
          sx={{
            maxWidth: '55px',
            whiteSpace: 'pre-line',
            lineHeight: '16px',
            fontWeight: 600,
          }}
        >
          {'Change\nNumber'}
        </Box>
      ),
      renderCell: (params) => params.api.getRowIndex(params.id) + 1,
      align: 'left' as const,
      headerAlign: 'left' as const,
      minWidth: 90,
    },
    {
      field: 'userName',
      headerName: 'User',
      minWidth: 200,
      sortable: false,
      filterable: false,
    },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 50,
      sortable: false,
      filterable: false,
    },
    {
      field: 'updatedAt',
      headerName: 'Change Time',
      minWidth: 210,
      sortable: false,
      filterable: false,
      align: 'center' as const,
      headerAlign: 'center' as const,
      renderCell: ({ value }) => (
        <Box>
          <Typography sx={{ fontSize: '9px', lineHeight: '20px', color: '#1D1D1D' }}>
            {value ? dayjs(value).format('MM/DD/YYYY') : ''}
          </Typography>
          <Typography sx={{ fontSize: '9px', lineHeight: '20px', color: '#98A2B3' }}>
            {value ? dayjs(value).format('h:mm:ss A') : ''}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'compare',
      headerName: 'Compare',
      minWidth: 50,
      sortable: false,
      filterable: false,
      renderCell: ({ row: { oldValue, newValue } }) => (
        <CompareCell oldValue={oldValue} newValue={newValue} />
      ),
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="lg"
      PaperProps={{
        sx: {
          width: '907px !important',
          borderRadius: '24px',
        },
      }}
    >
      <StyledDialogTitle>
        <StyledHeaderModal variant="h6">History</StyledHeaderModal>
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{
            ...stylesCloseIcon,
          }}
        >
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent
        sx={{
          px: '73px',
          '&.MuiDialogContent-root': {
            '& > .MuiBox-root': {
              height: 'initial',
            },
          },
          '& .MuiDataGrid-main > div': {
            height: '360px !important',
          },
        }}
      >
        <Table<SocialMediaHistoryType>
          apiRoute={`/admin/models/${modelId}/social-media-links/${id}/history?sortBy=createdAt&sortDirection=DESC`}
          columns={columns}
          withoutSearch
          checkHidePagination
          getRowId={(row) => row.id}
          customSxForTable={{
            '& .MuiDataGrid-row:last-child .MuiDataGrid-cell': {
              borderBottom: 'none',
            },
            '& .MuiDataGrid-columnHeaders': {
              fontSize: '11px',
              lineHeight: '16px',
              fontWeight: 600,
              padding: 0,
            },
            '& .MuiDataGrid-cell .MuiDataGrid-cellContent': {
              fontSize: '9px',
              lineHeight: '20px',
              fontWeight: 500,
            },
            '& .MuiDataGrid-columnHeader:first-child': {
              padding: 0,
            },
            '& .MuiDataGrid-cell[data-field="changeNumber"]': {
              paddingLeft: '20px',
            },
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
